<template>
  <div
    v-if="faq && faq.length"
    class="mx-0 m-auto mt-[120px] mb-[90px] rounded-[15px] overflow-hidden"
  >
    <div class="md:flex md:gap-[56px]">
      <div class="md:w-[55%]">
        <h1
          class="text-primary-1 text-mobile-heading-2 md:text-heading-2 title-font mb-2.5 max-md:text-center"
        >
          {{ $t("faq.header") }}
        </h1>
        <div class="my-[30px] mx-auto">
          <HomeFaqCard
            v-for="(item, i) in pageView ? faq : faq?.slice(0, 4)"
            :key="i"
            :question="item?.title"
            :answer="item?.content"
          />
        </div>
        <div class="text-center" v-if="!pageView && readAllButton">
          <BaseButton
            type="primary"
            class="!text-heading-6 !rounded-none max-md:!h-[54px] md:!h-[64px]"
            icon-class="rotate-90 bg-white text-primary-2 p-[10px] overflow-visible !mb-0  !text-[38px] rounded-full"
            append-icon="icon-arrow-up"
            label="Read All FAQs"
            @click="router.push(localePath('faq'))"
          />
        </div>
      </div>
      <div class="md:w-[45%]">
        <NuxtImg
          v-no-right-click
          class="w-full h-auto"
          :src="faqImg"
          alt="support"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const router = useRouter();
const localePath = useLocalePath();
const config = useRuntimeConfig();

const props = defineProps({
  pageView: {
    type: Boolean,
    required: false,
  },
  readAllButton: { type: Boolean, default: true },
  faqImg: { type: String, default: null },
});
const { locale } = useI18n();
const faq = config.public.statics.faq ?? [];
const { data: meta } = await useAsyncData(`faq-meta-${locale.value}`, () =>
  customFetch("api/meta-data/page/faq"),
);
const metaTags = ref(meta.value);
useHead(() => ({
  script: props.pageView
    ? faq
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify(useFAQPageSchema(faq)),
          },
        ]
      : []
    : [],
}));
// useSeoMeta({
//   ogTitle: metaTags.value ? metaTags.value.title : null,
//   description: metaTags.value ? metaTags.value.description : null,
//   ogDescription: metaTags.value ? metaTags.value.description : null,
// });
</script>
